
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { CTASection } from "@/sections/CTASection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { ConversionSection } from "@/sections/ConversionSection";

const FigjamToLucidChart = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/FigjamToLucidChart"
        ogImage="/images/figjam2lucidchart-og-image.jpg"
      />

      <MagicianSection
        title={t("page/FigjamToLucidChart:title")}
        subtitle={t("page/FigjamToLucidChart:subtitle")}
        magicianLogoFile="lucidchart"
        showStartsAt={false}
      >
        <Converter disabled />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/FigjamToLucidChart:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        backgroundColor="#fffffe"
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t(
          "page/FigjamToLucidChart:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
        image={{
          src: "/images/figjam-to-lucidchart-example.png",
          alt: "Figjam to LucidChart Example",
        }}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/FigjamToLucidChart:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/figjam-to-lucidchart-converted-file-elements.jpg",
          alt: t("page/FigjamToLucidChart:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/FigjamToLucidChart:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "NOTES",
            title: t(
              "page/FigjamToLucidChart:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/FigjamToLucidChart:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "CHECK-CIRCLED-EMPTY",
            title: t(
              "page/FigjamToLucidChart:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/FigjamToLucidChart:section/shareDesign.elements.folderStructureText",
            ),
          },
        ]}
        customStyle={{
          color: "green",
          nested: {
            "& li:nth-child(2) path": {
              fill: colors.GRADIENT_BLUE_DARK,
            },
          },
        }}
      />

      <ConversionSection
        title={t("page/FigjamToLucidChart:section/conversion.title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t(
              "page/FigjamToLucidChart:section/conversion.badges.supportsAll",
            ),
          },
          {
            iconType: "NOTES",
            text: t(
              "page/FigjamToLucidChart:section/conversion.badges.stickyNotes",
            ),
          },
          {
            iconType: "ARROW-BLACK",
            text: t(
              "page/FigjamToLucidChart:section/conversion.badges.connectors",
            ),
          },
        ]}
        elements={{
          from: {
            iconType: "FIGJAM",
            image: "/images/figjam-illustrator-preview.jpg",
            title: "Figjam Import LucidChart Preview",
          },
          to: {
            iconType: "LUCIDCHART",
            image: "/images/lucidchart-preview.jpg",
            title: "LucidChart Import Figjam Preview",
          },
        }}
      />

      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection
        title={t("section/cta:titles.figjamToLucidChartPage")}
        href="#upload"
        isBetaFormat
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default FigjamToLucidChart;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/figjam-to-lucidchart',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  